module.exports = __webpack_public_path__ + "static/img/blue.a6c8cf3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeimg/blue.gif
// module id = 9oUp
// module chunks = 1